import type { BtlApplication } from 'api/btlApplicationForm/types';
import { PropertyTenure } from 'api/btlApplicationForm/types';
import { monthsToYears } from 'utils/numbers';

export function mapApplicationToFormValues(data?: BtlApplication) {
  if (!data) {
    return { purpose: 'PURCHASE', feesAddedToBalance: false };
  }

  const { applicationProperty, termInMonths, feesAddedToBalance, purpose, ...rest } = data;

  if (purpose === 'PURCHASE') {
    rest.refinancePurpose = null;
  }

  const { tenure, yearsRemainingOnLease, estateAgent } = applicationProperty ?? {};
  const normalisedTenure: PropertyTenure | null = tenure === 'LEASEHOLD' || tenure === 'FREEHOLD' ? tenure : null;

  if (applicationProperty?.status === 'REJECTED') {
    return {
      ...rest,
      purpose,
      feesAddedToBalance: [feesAddedToBalance],
      estateAgent,
      termInMonths: termInMonths ? monthsToYears(termInMonths) : undefined,
      tenure: normalisedTenure,
      yearsRemainingOnLease,
    };
  }

  const {
    purchasePrice,
    grossMonthlyRentalPayment,
    propertyType,
    propertySubType,
    expectedPropertyType,
    address,
    attributes,
  } = applicationProperty?.property ?? {};
  const { numberOfBedrooms, hasCommunalSpace, numberOfUnits } = attributes ?? {};

  return {
    ...rest,
    purpose,
    purchasePrice,
    grossMonthlyRentalPayment,
    propertyType,
    propertySubType,
    expectedPropertyType,
    address: { ...address, isManual: true },
    termInMonths: termInMonths ? monthsToYears(termInMonths) : undefined,
    feesAddedToBalance: [feesAddedToBalance],
    estateAgent,
    tenure: normalisedTenure,
    yearsRemainingOnLease,
    numberOfBedrooms,
    hasCommunalSpace: [hasCommunalSpace],
    numberOfUnits,
  };
}
